var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconError = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.188 10.812 5.625-5.625m0 5.625L5.187 5.187M.97 7.999A7.031 7.031 0 1 0 15.03 8 7.031 7.031 0 0 0 .97 8"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.188 10.812 5.625-5.625m0 5.625L5.187 5.187M.97 7.999A7.031 7.031 0 1 0 15.03 8 7.031 7.031 0 0 0 .97 8"
  }));
});
export default SvgIconError;
export const raw = __webpack_public_path__ + "static/media/IconError.a3d199eb9dbf2e711c54e4581b5b09a7.svg";